export default {"src":"/_next/static/image/public/images/flags/flag_886.778d3791461779c52b00350ceef8187f.svg","height":16,"width":24};